import styled from 'styled-components';

import { AvartarType } from '@/components/Avatar/avatarConst';
import ProfileAvatar from '@/components/Avatar/ProfileAvatar';
import { Flex, VFlex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import type { Dashboard2T } from '@/features/Dashboard/types/types';
import { radius } from '@/styles/sizes';
import { getTimezoneDayjs } from '@/utils/time';

type Props = {
  dashboard: Dashboard2T;
  current?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
};

const DashboardItem = (props: Props) => {
  return (
    <Style
      onClick={props.onClick}
      isCurrent={!!props.current}
      style={props.style}
    >
      <Flex g={6}>
        <Typo
          type="body1"
          weight="sb"
          style={{
            wordBreak: 'break-all',
            flex: 1,
          }}
          multilineEllipsis={2}
        >
          {props.dashboard.title}
        </Typo>
      </Flex>
      <Flex g={10} j="space-between" a="center">
        <ProfileAvatar
          type={AvartarType.MEMBER}
          text={props.dashboard.updated_by}
          withText
        />
        <Typo type="label3" className="text-gray-700">
          {getTimezoneDayjs(props.dashboard.updated_at).fromNow()}
        </Typo>
      </Flex>
    </Style>
  );
};

const Style = styled(VFlex)<{ isCurrent: boolean }>`
  flex: 1;
  position: relative;
  cursor: pointer;
  justify-content: space-between;
  color: ${(props) => props.theme.colors.gray900};
  height: 158px;
  padding: 20px 24px;
  border-radius: ${radius.token.lg}px;
  border: 1px solid
    ${(props) =>
      props.isCurrent
        ? props.theme.colors.primary100
        : props.theme.colors.gray300};
  transition: all 0.2s ease-in-out;
  box-shadow: ${(props) => props.theme.shadow[2]};
  &:hover {
    transform: translateY(-6px);
  }
`;

export default DashboardItem;
